import React, { useState, useEffect } from 'react'

import sanityClient, { urlFor } from '../client'

import ImageGallery from 'react-image-gallery';

const GalleryComponent = ({ query }) => {
    const [galleryImages, setGalleryImages] = useState(null)

    useEffect(() => {
        // fetch the image object instead of the raw CDN url so we can build transformed urls
        sanityClient
            .fetch(
                `*[_type == "${query}"]|order(orderRank){
          "image": img,
          desc
        }`
            )
            .then((data) => setGalleryImages(data))
            .catch(console.error);
    }, [query]);

    if (!galleryImages) {
        return (
            <h1>Loading...</h1>
        )
    }

    const images = galleryImages.map((item) => {
        const img = item.image
        // original: medium/large, thumbnail: small; auto-format (WebP) and fit to max width
        const original = urlFor(img).width(1200).url()
        const thumbnail = urlFor(img).width(340).height(240).url()

        return {
            original,
            thumbnail,
            description: item.desc || ''
        }
    })

    return <ImageGallery
        items={images}
        showPlayButton={false}
        lazyLoad={true}
    />;
}

export default GalleryComponent